import { LeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const HeaderCard = () => {
  const navigate = useNavigate()
  return (
    <div className='mx-4'>
      <div className='flex py-5'>
        <LeftOutlined
          className=' cursor-pointer'
          style={{ fontSize: '24px' }}
          onClick={() => navigate('/')}
        />
        <div className='text-[#00D4FF] w-full font-bold sm:text-2xl text-lg'>
          <div className='flex justify-center'>ポイントチャージ</div>
        </div>
      </div>
      <div className='flex justify-center mb-12'>
        <img src='/logo-card.svg' className='lg:h-16 h-8' />
      </div>
    </div>
  )
}
export default HeaderCard
